module.exports = __webpack_public_path__ + "img/plus.e3d748d7.svg";